/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Building_Frost_Free_Mode_ActivatedInputs */



/**
* | output |
* | --- |
* | "Building frost-free mode activated" |
*
* @param {Building_Frost_Free_Mode_ActivatedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const building_frost_free_mode_activated = /** @type {((inputs?: Building_Frost_Free_Mode_ActivatedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Building_Frost_Free_Mode_ActivatedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Building frost-free mode activated")
	return /** @type {LocalizedString} */ ("Hors gel bâtiment activé")
});